import {
  getAuthTokenValue,
  setAuthToken,
  removeAuthToken,
  AuthTokenCookieConfig,
} from '@kaihong/utils/lib/khAuthToken';

export const TOKEN_KEY = 'X-Access-Token';
export const TOKEN_KEY_OTHER = 'Authorization';

const Token = {
  set: (token: string) => {
    setAuthToken(TOKEN_KEY, token, {
      expires: AuthTokenCookieConfig.expires,
      path: AuthTokenCookieConfig.path,
      domain: AuthTokenCookieConfig.domain,
    });
    setAuthToken(TOKEN_KEY_OTHER, token, {
      expires: AuthTokenCookieConfig.expires,
      path: AuthTokenCookieConfig.path,
      domain: AuthTokenCookieConfig.domain,
    });
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_KEY_OTHER, token);
  },
  get: (onCookie = false) => {
    if (onCookie) {
      return getAuthTokenValue(TOKEN_KEY);
    }
    return getAuthTokenValue(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  },
  /**
   * @description 移除token
   * @param force 是否强制移除，如果为true，则移除cookie和localStorage中的token
   * 强制移除的场景：
   * 1. 用户主动退出登录
   */
  remove: (force = false) => {
    if (force) {
      removeAuthToken(TOKEN_KEY);
      removeAuthToken(TOKEN_KEY_OTHER);
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY_OTHER);
    }
  },
};
export default Token;

export const UserInfo = {
  set: (userInfo: string) => localStorage.setItem('USER_INFO', userInfo),
  get: () => localStorage.getItem('USER_INFO') || '{}',
  remove: () => localStorage.removeItem('USER_INFO'),
};
